import React from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../hooks/useTheme';
import { LogInIcon, LogOutIcon, SunIcon, MoonIcon } from './icons';

interface HeaderProps {
    isAdminAuthenticated: boolean;
    onLogout?: () => void;
    onContextMenu?: (e: React.MouseEvent) => void;
}

const Header: React.FC<HeaderProps> = ({ isAdminAuthenticated, onLogout, onContextMenu }) => {
    const { theme, toggleTheme } = useTheme();

    return (
        <header onContextMenu={onContextMenu} className="absolute top-0 left-0 right-0 p-4 bg-transparent flex justify-between items-center z-10">
            <h1 className="hidden sm:block text-2xl font-bold text-gray-900 dark:text-white tracking-wider">KioskTimeClock</h1>
            <div className="absolute right-0 top-0 p-4 flex items-center gap-6">
                {isAdminAuthenticated && (
                    <>
                        <Link to="/admin" className="flex items-center gap-2 text-gray-500 dark:text-gray-light hover:text-gray-900 dark:hover:text-white transition-colors duration-200">
                            <LogInIcon />
                            Admin Panel
                        </Link>
                        <button onClick={onLogout} className="flex items-center gap-2 text-gray-500 dark:text-gray-light hover:text-gray-900 dark:hover:text-white transition-colors duration-200">
                            <LogOutIcon />
                            Logout
                        </button>
                    </>
                )}
                 <button
                    onClick={toggleTheme}
                    className="flex items-center justify-center p-2 rounded-full text-gray-500 dark:text-gray-400 hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors duration-200"
                    aria-label="Toggle theme"
                >
                    {theme === 'light' ? <MoonIcon className="w-5 h-5"/> : <SunIcon className="w-5 h-5"/>}
                </button>
            </div>
        </header>
    );
};

export default Header;